"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { DefaultImage } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"

import { RenderConfig } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/RenderConfig"
import type { PromotionShowcaseProps } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/types/config"

export const PromotionShowcase: ComponentConfig<PromotionShowcaseProps> = {
    label: "Tamda Group | Promotion Showcase",
    fields: {
        sectionTitle: {
            label: "Section Title",
            type: "text",
        },
        logo: {
            label: "Logo",
            type: "custom",
            render: props => <MediaSelect {...props} mediaType="image" />,
        },
        promotions: {
            label: "Promotions",
            type: "array",
            arrayFields: {
                title: {
                    label: "Title",
                    type: "text",
                },
                outsideBackgroundImage: {
                    label: "Background Image",
                    type: "custom",
                    render: props => <MediaSelect {...props} mediaType="image" />,
                },
                insideBackgroundImage: {
                    label: "Inside Background Image",
                    type: "custom",
                    render: props => <MediaSelect {...props} mediaType="image" />,
                },
                buttonText: {
                    label: "Button Text",
                    type: "text",
                },
                buttonLink: {
                    label: "Button Link",
                    type: "text",
                },
            },
            getItemSummary: (item) => item.title || "Promotion",
            defaultItemProps: {
                title: "Promotion",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
        },

        slidesPerView: {
            label: "Slides Per View",
            type: "number",
            min: 1,
            max: 6,
        },
        spaceBetween: {
            label: "Space Between (px)",
            type: "number",
            min: 0,
            max: 100,
        },

        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {
        sectionTitle: "Chương trình khuyến mãi",
        logo: DefaultImage,

        promotions: [
            {
                title: "Trúng thưởng cùng Mattoni",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
            {
                title: "Nhận ngay bình Twistshake!",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
            {
                title: "Cơ hội trúng ASUS Vivobook Gaming V16!",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
            {
                title: "Trúng đèn hồng ngoại trị liệu MITO LIGHT!",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
            {
                title: "MUA 5 TẶNG 1!",
                outsideBackgroundImage: DefaultImage,
                insideBackgroundImage: DefaultImage,
                buttonText: "",
                buttonLink: "#",
            },
        ],
        slidesPerView: 5,
        spaceBetween: 20,
        className: "",
    },
    ...RenderConfig,
}

export type { PromotionItem, PromotionShowcaseProps } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/types/config"

